/* Archival redesign: collection page behaviours (filter sheet/sidebar, ajax filtering, grid/collage). */
(function () {
  function init(root) {
    if (root.__aaCol) return;
    root.__aaCol = true;
    var toggle = root.querySelector('[data-aa-filter-toggle]');

    // selected size/color chips carry a hand-drawn loop; assets/aa-loop.js draws it when aria-pressed flips to true
    function armLoops() {
      Array.prototype.forEach.call(root.querySelectorAll('.aa-fl label[data-on]'), function (l) {
        var svg = l.querySelector('.aa-loop');
        if (!svg || svg.dataset.drawn || !l.offsetParent) return;
        l.setAttribute('aria-pressed', 'false');
        l.setAttribute('aria-pressed', 'true');
      });
    }
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.type !== 'checkbox' || !t.nextElementSibling || !t.nextElementSibling.hasAttribute('aria-pressed')) return;
      var l = t.nextElementSibling;
      if (t.checked) l.setAttribute('data-on', ''); else l.removeAttribute('data-on');
      l.setAttribute('aria-pressed', t.checked ? 'true' : 'false');
    });
    setTimeout(armLoops, 60);

    var flAside = root.querySelector('.aa-fl');
    var isPhone = function () { return window.matchMedia('(max-width: 749px)').matches; };
    function setModal(on) {
      if (!flAside) return;
      if (on) { flAside.setAttribute('role', 'dialog'); flAside.setAttribute('aria-modal', 'true'); }
      else { flAside.removeAttribute('role'); flAside.removeAttribute('aria-modal'); }
      [].forEach.call(document.querySelectorAll('.header-group, .shopify-section-group-footer-group'), function (el) {
        if (on) el.setAttribute('inert', ''); else el.removeAttribute('inert');
      });
    }
    function setOpen(open, focus) {
      if (open) root.setAttribute('data-filters-open', ''); else root.removeAttribute('data-filters-open');
      setModal(open && isPhone());
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) armLoops();
      if (open && focus) { var f = root.querySelector('.aa-fl summary'); if (f) f.focus(); }
      if (!open && focus && toggle) toggle.focus();
    }
    if (toggle) toggle.addEventListener('click', function () { setOpen(!root.hasAttribute('data-filters-open'), true); });
    root.addEventListener('click', function (e) {
      var c = e.target.closest('[data-aa-filter-close]');
      if (c) { e.preventDefault(); setOpen(false, true); }
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.hasAttribute('data-filters-open') && window.matchMedia('(max-width: 749px)').matches) setOpen(false, true);
      // keep Tab inside the open mobile drawer
      if (e.key === 'Tab' && flAside && flAside.getAttribute('aria-modal') === 'true') {
        var f = [].filter.call(flAside.querySelectorAll('a[href], button, input, select, summary, [tabindex]:not([tabindex="-1"])'), function (x) { return !x.disabled && x.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    // desktop default: mobile never starts open
    if (root.hasAttribute('data-filters-open') && window.matchMedia('(max-width: 749px)').matches) setOpen(false, false);

    // grid / collage
    var vbtns = root.querySelectorAll('[data-aa-view]');
    function setView(v, save) {
      root.setAttribute('data-view', v);
      Array.prototype.forEach.call(vbtns, function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-aa-view') === v ? 'true' : 'false'); });
      if (save) { try { localStorage.setItem('aa-col-view', v); } catch (e) {} }
    }
    Array.prototype.forEach.call(vbtns, function (b) { b.addEventListener('click', function () { setView(b.getAttribute('data-aa-view'), true); }); });
    setView(root.getAttribute('data-view') || 'grid', false);

    // ajax filtering
    var form = root.querySelector('[data-aa-filter-form]');
    var sort = root.querySelector('[data-aa-sort]');
    function formUrl() {
      var p = new URLSearchParams();
      var fd = new FormData(form);
      fd.forEach(function (v, k) { if (v !== '') p.append(k, v); });
      if (sort && sort.value) p.set('sort_by', sort.value);
      var q = p.toString();
      return form.getAttribute('action') + (q ? '?' + q : '');
    }
    function load(url, push) {
      root.classList.add('is-loading');
      fetch(url, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nr = doc.querySelector('[data-aa-col]');
        if (!nr) throw new Error('no section');
        var open = {};
        Array.prototype.forEach.call(root.querySelectorAll('.aa-fl__group'), function (d) { open[d.getAttribute('data-group')] = d.open; });
        // remember what had focus (checkbox name AND value, or its group) so the refresh can put it back (audit R6-01)
        var ae = document.activeElement, fk = null;
        if (ae && ae !== document.body && root.contains(ae)) {
          var grp = ae.closest('.aa-fl__group');
          fk = { name: ae.name || '', value: ae.value || '', group: grp ? grp.getAttribute('data-group') : '', clear: ae.hasAttribute('data-aa-ajax') };
        }
        ['[data-aa-swap]', '[data-aa-results]', '[data-aa-groups]', '[data-aa-count]', '[data-aa-clear]', '[data-aa-filter-toggle]'].forEach(function (sel) {
          var a = root.querySelector(sel), b = nr.querySelector(sel);
          if (a && b) a.innerHTML = b.innerHTML;
        });
        Array.prototype.forEach.call(root.querySelectorAll('.aa-fl__group'), function (d) {
          var k = d.getAttribute('data-group');
          if (k in open) d.open = open[k] || d.open;
        });
        armLoops();
        if (fk) {
          var esc = function (v) { return window.CSS && CSS.escape ? CSS.escape(v) : String(v).replace(/["\\]/g, '\\$&'); };
          var f = null;
          if (fk.name) f = root.querySelector('[name="' + esc(fk.name) + '"][value="' + esc(fk.value) + '"]') || (fk.value ? null : root.querySelector('[name="' + esc(fk.name) + '"]'));
          if (!f && fk.group) { var g2 = root.querySelector('.aa-fl__group[data-group="' + esc(fk.group) + '"]'); f = g2 && (g2.querySelector('input:not([disabled])') || g2.querySelector('summary')); }
          if (!f) { var panel = root.querySelector('[data-aa-groups]'); f = panel && panel.querySelector('input:not([disabled]), summary, button, a[href]'); }
          if (f) f.focus({ preventScroll: true });
        }
        if (push !== false) history.pushState({ aa: 1 }, '', url);
        var top = root.querySelector('.aa-col__bar');
        if (top && top.getBoundingClientRect().top < 0) top.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }).catch(function () { window.location.href = url; }).then(function () { root.classList.remove('is-loading'); });
    }
    if (form) {
      form.addEventListener('change', function () { load(formUrl()); });
      // the sort <select> sits outside the form (linked by form="…"): its change event never bubbles to the form
      if (sort && !form.contains(sort)) sort.addEventListener('change', function () { load(formUrl()); });
      form.addEventListener('submit', function (e) { e.preventDefault(); load(formUrl()); });
    }
    if (sort && !form) sort.addEventListener('change', function () { window.location.search = 'sort_by=' + encodeURIComponent(sort.value); });
    root.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-aa-ajax]');
      if (a && form) { e.preventDefault(); load(a.getAttribute('href')); }
    });
    window.addEventListener('popstate', function () { window.location.reload(); });
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-aa-col]'), init); }
  boot();
  document.addEventListener('shopify:section:load', boot);
})();
